<template>
  <div>
    <div class="mb-2">
      <LoginProfile
        :greeting="$label('user.signUp.loginWelcome')"
        :name="profile.fullName"
        :email="profile.email"
        :img="profile.photo"
        class="mb-16"
      />
    </div>
    <div>
      <BaseButton
        :disabled="isLoading"
        :class="{ loading: isLoading }"
        variant="primary"
        class="mb-16 w-100"
        data-nw="already-logged-in"
        @click.prevent="onSubmit"
      >
        {{ $label('user.signUp.loggedInNextStep') }}
      </BaseButton>
    </div>
    <div class="d-flex justify-content-center">
      <BaseButton
        variant="link"
        aria-label="logout"
        :class="{ loading: isLoggingOut }"
        @click.prevent="onClick"
      >
        {{ $label('common.header.signOutAndLoginWithAnotherAccount') }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import LoginProfile from '~/components/LoginProfile'
import { useAuthLib } from '~/composables/useAuthLib'

export default {
  components: {
    LoginProfile,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    profile: {
      type: Object,
      required: true,
    },
    onSubmit: {
      type: Function,
      required: true,
    },
  },
  setup() {
    const { signOut } = useAuthLib()

    return { signOut }
  },
  data() {
    return {
      isLoggingOut: false,
    }
  },
  methods: {
    async onClick() {
      try {
        this.isLoggingOut = true
        await this.signOut()
      } catch (error) {
        this.$sentryCaptureException(error)
        this.$toast.error(this.$label('messages.errorOccuredMessage'))
      } finally {
        this.isLoggingOut = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-link.loading::after {
  border-bottom-color: black !important;
  border-right-color: black !important;
  border-left-color: black !important;
}
</style>
